import axios from "axios";
import { setAuthHeader } from "./auth.header.service";
import {
    getUrlToCreateDepartment,
    getUrlToDeleteDepartment,
    getUrlToFetchAllDepartments,
    getUrlToUpdateDepartment,
} from "utils/endpointUtils/departmentEndpointUtil";

// @since NEXT_VERSION
// `status` omitted returns every department (the master grid needs disabled ones so they can be
// re-enabled); pass "ACTIVE" for the Add/Edit User dropdown feed.
export const loadAllDepartments = async (status) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.get(getUrlToFetchAllDepartments(status), config);
};

// @since NEXT_VERSION
export const addDepartmentToBackend = async (data) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.post(getUrlToCreateDepartment(), data, config);
};

// @since NEXT_VERSION
export const updateDepartmentToBackend = async (departmentId, data) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.put(getUrlToUpdateDepartment(departmentId), data, config);
};

// @since NEXT_VERSION
// Soft delete server-side: the row survives with status DISABLED.
export const deleteDepartment = async (departmentId) => {
    const config = setAuthHeader();
    if (config === null) throw new Error("Invalid Auth Header or Token Expired");

    return await axios.delete(getUrlToDeleteDepartment(departmentId), config);
};
